export const setScrollDisabled = (value: boolean) => {
  if (!document) {
    return
  }

  const el = document.documentElement

  if (value) {
    el.style.overflowY = 'hidden !important'
  } else {
    el.style.overflowY = ''
  }
}
